module.exports = __webpack_public_path__ + "static/media/26_galeria_plantilla_navidad_combo_simple_cuadrada_motivo_1.5c41e156.png";